<div class="conf-ticket">
    <div
        class="conf-ticket__item"
        (click)="selectTicket(amount)"
        *ngFor="let amount of ticketAmount"
        [ngClass]="{ 'conf-ticket__item--active': getActive() === amount }"
    >
        {{ amount }}
    </div>
    <div
        class="conf-ticket__zero conf-ticket__item"
        (click)="selectTicket(0)"
        [ngClass]="{ 'conf-ticket__item--active': getActive() === 0 }"
    >
        0
    </div>
</div>
